export default function() {
    $(function () {
        $('#anchors-tabs .anchors-sections a').on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) {
                return;
            }
    
            if (!$(this).hasClass('active')) {
                let currentTab = $(this).attr('href');
                let currentTabPosition = $(this).position().left + 10;
                let currentTabWidth = -$(this).outerWidth() / 2;
    
                $('#anchors-tabs .anchors-sections a').removeClass('active');
                $('#anchors-tabs .tabs-content').hide();
    
                $(this).addClass('active');
    
                $(currentTab)
                    .show()
                    // place arrow on middle of anchor
                    .find('.arrow-top').css({
                        left: currentTabPosition,
                        marginLeft: -currentTabWidth
                    });
            } else {
                $('#anchors-tabs .anchors-sections a').removeClass('active');
                $('#anchors-tabs .tabs-content').hide();
            }
        });
    
        $('.tabs-content-header .icon-close').on('click', function () {
            $(this).closest('.tabs-content').css('display', 'none');
            $('.anchors-sections a.active').removeClass('active');
        });
    });    
}